(ns machtfit.stepchall.share-team
  (:require [machtfit.app.routes :as routes]
            [machtfit.stepchall.countdown :as countdown]
            [machtfit.stepchall.icons :as icons]
            [machtfit.stepchall.subs :as subs]
            [machtfit.translation :refer [t]]
            [machtfit.widgets.box :as box]
            [machtfit.widgets.icon :as icon]
            [re-frame.core :as rf]))

(rf/reg-sub ::join-team-url
  :<- [:get [:stepchall :team :access-code]]
  :<- [:get [:stepchall :team :id]]
  :<- [:get [:subdomain-info :base-url]]

  (fn [[team-access-code team-id subdomain-url] _]
    (str subdomain-url
         (routes/page-url {:id :stepchall
                           :subpage :join-team
                           :team-id team-id
                           :team-access-code team-access-code}))))

(rf/reg-event-db ::link-copy-result-expired
  (fn [db _]
    (update-in db [:ui :stepchall] dissoc :link-copy-result)))

(rf/reg-event-fx ::link-copy-succeeded
  (fn [{:keys [db]} _]
    {:db (assoc-in db [:ui :stepchall :link-copy-result] :success)
     :dispatch-debounce {:key :link-copy-result-expired
                         :event [::link-copy-result-expired]
                         :delay 3000}}))

(rf/reg-event-fx ::link-copy-failed
  (fn [{:keys [db]} _]
    {:db (assoc-in db [:ui :stepchall :link-copy-result] :failure)
     :dispatch-debounce {:key :link-copy-result-expired
                         :event [::link-copy-result-expired]
                         :delay 3000}}))

(defn copy-link []
  (let [copy-result @(rf/subscribe [:get [:ui :stepchall :link-copy-result]])
        url @(rf/subscribe [::join-team-url])]
    [:button.sc_share-button
     {:class (case copy-result
               :success "success"
               :failure "error"
               nil)
      :on-click (fn []
                  (-> js/navigator .-clipboard (.writeText url)
                      (.then #(rf/dispatch [::link-copy-succeeded]))
                      (.catch (fn [e]
                                (js/console.error "Failed to copy join team URL" e)
                                (rf/dispatch [::link-copy-failed])))))}
     (case copy-result
       :success [:<> [icons/tick] (t {:de "Link kopiert" :en "Link copied"})]
       :failure [:<> [icons/close] (t {:de "Kopieren fehlgeschlagen" :en "Copy failed"})]
       [:<> [icons/copy-link] (t {:de "Link kopieren" :en "Copy link"})])]))

(defn- invitation-body []
  (let [team-name (t @(rf/subscribe [:get [:stepchall :team :name]]))]
    (t {:de (str "Hallo, ich möchte dich gerne in mein machtfit-Challenge-Team \"" team-name "\" einladen.")
        :en (str "Hello, I would like to invite you to my machtfit-Challenge-Team \"" team-name "\"")})))

(defn email-link []
  (let [url @(rf/subscribe [::join-team-url])
        subject (t {:de "Werde Teil meines Teams: Einladung zur machtfit-Challenge"
                    :en "Join my team: Invitation to the machtfit-Challenge"})]
    [:a.sc_share-button
     {:href (str "mailto:?subject=" subject "&body=" (invitation-body) " " url)}
     [icons/share-email]
     (t {:de "Via E-Mail einladen"
         :en "Invite via email"})]))

(defn whatsapp-link []
  (let [url @(rf/subscribe [::join-team-url])]
    [:a.sc_share-button
     {:href (str "https://api.whatsapp.com/send?text=" (invitation-body) " " url)
      :target "_blank"}
     [icons/share-whatsapp]
     (t {:de "Via WhatsApp einladen"
         :en "Invite via WhatsApp"})]))

(defn- team-info []
  (when-let [access-code @(rf/subscribe [:get [:stepchall :team :access-code]])]
    [:div.sc_team-info
     [:i.sc_icon [icons/locker]]
     [:div
      [:p (t {:de "Dein Team ist privat. Um jemanden ins Team einzuladen, teile einfach den Zugangscode: "
              :en "Your team is private. Others can access it using the code: "})
       [:strong access-code]]]]))

(defn team-minimum-size-warning []
  (let [min-team-size @(rf/subscribe [:get [:stepchall :min-team-size]])]
    [box/info
     {:icon [:div.flex.w-10.h-10.justify-center.items-center.rounded-full.bg-warning-50.text-brand-500 {:class "p-2.5"}
             [icon/outline "info-circle" {:class "text-warning-500"
                                          :width "h-5"
                                          :height "w-5"}]]
      :content [:div.flex.flex-col.gap-2
                [:strong (t {:de "Dein Team ist noch nicht vollständig"
                             :en "Your team is not yet complete"})]
                [:p (t {:de [:<> "Dein Team braucht mindestens "
                             min-team-size
                             " Mitglieder. Sollte die Mindestanzahl bis zum Ende der Anmeldefrist nicht erreicht werden, werden alle Teammitglieder automatisch Teil des Offenen Teams."]
                        :en [:<> "Your team needs at least "
                             min-team-size
                             " members. If the minimum number is not reached by the end of the registration period, all team members will automatically become part of the Open Team."]})]]}]))

(defn share-team []
  (when @(rf/subscribe [::subs/in-team-building-phase?])
    (let [countdown (countdown/countdown {:from @(rf/subscribe [:get [:clock :current-server-time]])
                                          :until @(rf/subscribe [:get [:stepchall :team-building-end]])})]
      [:div.sc_share
       [:div {:style {:text-align "center"}}
        [:h3 (t {:de "Lade jetzt Kolleg:innen in dein Team ein!"
                 :en "Invite your coworkers to join the team!"})]
        [:p.sc_subtitle (t {:de (str "Noch " countdown)
                            :en (str countdown " left")})]]
       [copy-link]
       [whatsapp-link]
       [email-link]
       [team-info]])))
